import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { callActions } from '@lifesize/nucleus';
import { closeInCallModal } from 'actions/InCallModal';
import { DISPLAY_SHARING_SETTINGS_MODAL } from 'actions/SharingPermissions';
import InCallModal from 'components/InCallModal/InCallModal';
import AvSettingsModal from 'components/AvSettings/AvSettingsModal';
import { PASSCODE_MODAL } from 'constants/PasscodeModal';
import { AV_SETTINGS } from 'constants/AvSettingsModal';
import Modals from 'constants/Modals';
import SharingPermissionsModal from 'containers/SharingPermissionsModal/SharingPermissionsModal';
import EndCallForAllModal from 'containers/EndCallForAllModal/EndCallForAllModalContainer';
import PasscodeModal from 'containers/PasscodeModal/PasscodeModalContainer';
import RemoveFromMeetingModal from 'containers/RemoveFromMeetingModal/RemoveFromMeetingModalContainer';
import ConfirmEndRemoteModeration from 'containers/ConfirmEndRemoteModerationContainer';
import StopPresenterModal from 'containers/StopPresenterModalContainer';
import StopPresentationModal from 'components/StopPresentationModal/StopPresentationModal';
import WaitingRoomWarningModal from 'components/InCall/WaitingRoomWarningModal';

const mapDispatchToProps = (dispatch) => ({
  onCloseClicked: (visibleComponent) => {
    if (visibleComponent && visibleComponent === PASSCODE_MODAL) {
      dispatch(callActions.end());
    } else {
      dispatch(closeInCallModal());
    }
  }
});

const visibleComponent = (state, isWaitingForPin) => {
  return isWaitingForPin ? PASSCODE_MODAL : _get(state, 'app.inCallModal.visibleComponent');
};

const compProps = (state) => _get(state, 'app.inCallModal.props');

const getSubComponent = (selectedComponent, props) => {
  switch (selectedComponent) {
    case PASSCODE_MODAL:
      return <PasscodeModal />;
    case Modals.endRemoteModeration:
      return <ConfirmEndRemoteModeration />;
    case Modals.endCallForAll:
      return <EndCallForAllModal {...props} />;
    case Modals.removeFromMeeting:
      return <RemoveFromMeetingModal {...props} />;
    case AV_SETTINGS:
      return <AvSettingsModal />;
    case Modals.stopPresenter:
      return <StopPresenterModal {...props} />;
    case DISPLAY_SHARING_SETTINGS_MODAL:
      return <SharingPermissionsModal />;
    case Modals.stopPresentation:
      return <StopPresentationModal />;
    case Modals.waitingRoomWarningModal:
      return <WaitingRoomWarningModal />;
    default:
      return <div />;
  }
};

const mapStateToProps = (state, ownProps) => {
  const currentVisibleComponent = visibleComponent(state, ownProps.pinRequested);
  let zIndex;
  switch (currentVisibleComponent) {
    case PASSCODE_MODAL:
      zIndex = 1030;
      break;
    case Modals.endCallForAll:
      zIndex = 1040;
      break;
    default:
      zIndex = 1040;
  }

  return {
    visibleComponent: currentVisibleComponent,
    children: getSubComponent(currentVisibleComponent, compProps(state)),
    zIndex
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, ownProps, stateProps, dispatchProps, {
    onCloseClicked: () => dispatchProps.onCloseClicked(stateProps.visibleComponent)
  });

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps)(InCallModal);

const FunctionalWrapper = (props) => {
  const pinRequested = hooks.usePinRequested();
  return <ConnectedComponent {...props} pinRequested={pinRequested} />;
};

export { ConnectedComponent as InCallModalContainer };
export default FunctionalWrapper;
